<div class="rating-distribution-wrapper">
  <div class="display-flex flex-align-center">
    <span class="sub-header">Rating Distribution</span>
    <va-icon 
    isFontAwesome="true"
    [name]="faInfoCircle"
    class="rating-distribution-icon"
    nz-popover
    nzPopoverTitle="Rating Distribution"
    [nzPopoverContent]="ratingDistToolTipTemplate"
    nzPopoverTrigger="click"
    nzPopoverPlacement="right"
  ></va-icon>
  </div>
  <div class="rating-distribution-count" *ngIf="tprConsensusDataReady">
    {{ sumOfBrokerWithBuyHoldSellRating || "-" }} /
    {{ totalBrokers || "-" }} Brokers
  </div>

  <ng-template #ratingDistToolTipTemplate>
    <div style="width: 400px; color: #000000A6;">
      All contributor ratings are normalized to a typical Buy-Hold-Sell scale,
      with a corresponding score being assigned.
      <br />
      <br />
      The visualization below shows the distribution of all normalized ratings
      included within the rating consensus calculation.
      <br />
      <br />
      Each section can be clicked to filter the results in the grid below
      <br />
      <br />
      <a
        href="https://support.visiblealpha.com/hc/en-us/articles/16525196418068-Getting-Started-with-Insights-Target-Price-and-Ratings-for-the-Sell-Side#01H2X95WW7SZ2588GN9GGKJEA9"
        target="_blank"
      >
        Learn More
      </a>
    </div>
  </ng-template>
  <div class="rating-distribution-chart-wrapper">
    <div class="rating-distribution-chart">
      <highcharts-chart
        class="pie-chart"
        [Highcharts]="highcharts"
        [options]="chartOptions"
      ></highcharts-chart>
    </div>

    <div
      *ngIf="tprConsensusDataReady && !sumOfBrokerWithBuyHoldSellRating"
      class="no-ratings-label"
    >
      No Ratings
    </div>
  </div>
</div>
